import React, { useState, useEffect } from 'react';
import {
  PlatformSection,
  PlatformTitle,
  VideoContainer,
  VideoOverlay,
  PlayButton,
  VideoFrame
} from './PlatformVideoStyles';

// Função JavaScript para abrir o vídeo em uma nova janela com um player nativo em modo fullscreen
function openNativePlayerWindow(videoSrc) {
  // Essa função vai ser injetada na nova janela para controlar o vídeo
  const playerScript = `
    document.addEventListener('DOMContentLoaded', function() {
      const video = document.getElementById('fullscreen-video');
      if (video) {
        video.controls = true;
        
        // Tentar reproduzir automaticamente
        video.play().catch(function(e) { 
          console.warn('Não foi possível reproduzir automaticamente:', e); 
        });
        
        // Lidar com o fechamento da janela
        window.addEventListener('unload', function() {
          try {
            if (window.opener && !window.opener.closed) {
              window.opener.postMessage({
                type: 'fullscreenClosed'
              }, '*');
            }
          } catch(e) {
            console.warn('Erro ao comunicar com janela principal:', e);
          }
        });
      }
    });
  `;

  // HTML simples para a nova janela com o player nativo
  const playerHTML = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>BIANCA - Por dentro da plataforma</title>
      <style>
        body, html { 
          margin: 0; 
          padding: 0; 
          width: 100%; 
          height: 100%; 
          overflow: hidden;
          background-color: #000;
        }
        #fullscreen-video {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      </style>
      <script>${playerScript}</script>
    </head>
    <body>
      <video id="fullscreen-video" src="${videoSrc}" autoplay controlsList="nodownload" disablePictureInPicture></video>
    </body>
    </html>
  `;

  // Abrir uma nova janela com o tamanho máximo possível
  const windowFeatures = "popup,fullscreen=yes,width=" + window.screen.width + ",height=" + window.screen.height;
  const playerWindow = window.open("", "videoPlayer", windowFeatures);
  
  if (playerWindow) {
    playerWindow.document.write(playerHTML);
    playerWindow.document.close();
    
    // Focar na nova janela
    playerWindow.focus();
    
    return playerWindow;
  }
  
  return null;
}

const PlatformVideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [playerWindow, setPlayerWindow] = useState(null);
  const videoUrl = process.env.PUBLIC_URL + '/videos/bianca_demo.mp4'; // Caminho para o vídeo local
  
  // Mensagem de volta da janela de fullscreen
  useEffect(() => {
    const handleMessage = (event) => {
      // Verificar se a mensagem veio da janela do player
      if (playerWindow && event.source === playerWindow) {
        const data = event.data;
        
        if (data && data.type === 'fullscreenClosed') {
          // Resetar para o estado de miniatura
          setIsPlaying(false);
          setPlayerWindow(null);
        }
      }
    };
    
    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [playerWindow]);
  
  // Verifica se a janela de fullscreen foi fechada
  useEffect(() => {
    if (playerWindow) {
      const checkWindow = setInterval(() => {
        if (playerWindow && playerWindow.closed) {
          setIsPlaying(false);
          setPlayerWindow(null);
          clearInterval(checkWindow);
        }
      }, 500);
      
      return () => {
        clearInterval(checkWindow);
      };
    }
  }, [playerWindow]);
  
  const handlePlayClick = () => {
    // Obter a URL absoluta do vídeo
    const videoPath = new URL(videoUrl, window.location.origin).href;
    
    // Abrir a nova janela com o player nativo em fullscreen
    const newWindow = openNativePlayerWindow(videoPath);
    
    if (newWindow) {
      setPlayerWindow(newWindow);
      setIsPlaying(true);
    } else {
      // Se não foi possível abrir a janela, mostrar um alerta
      alert('Não foi possível abrir o modo de tela cheia. Verifique se os pop-ups estão permitidos.');
    }
  };
  
  return (
    <PlatformSection>
      <PlatformTitle>POR DENTRO DA PLATAFORMA</PlatformTitle>
      
      <VideoContainer>
        {/* Overlay com botão de play que sempre fica visível já que o vídeo é aberto em outra janela */}
        <VideoOverlay isPlaying={false} onClick={handlePlayClick}>
          <PlayButton />
        </VideoOverlay>
      </VideoContainer>
    </PlatformSection>
  );
};

export default PlatformVideoSection;
